import React from 'react';
import * as paths from "../paths";
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AuthRoute = ({ component: Component, ...props }:any) => {
	const { auth } = useSelector((state: any) => {
    return state;
  });
	let isAuthenticated = false;
	if(auth.isAuth && auth.userType === 'agents')
		isAuthenticated = true;
  return (
    <Route
      {...props}
      render={innerProps => (isAuthenticated ? <Component {...innerProps} /> : <Redirect to={paths.AGENT_LOGIN} />)
      }
    />
  );
};

export default AuthRoute